export class StoreSelection {
    storeGuid: string;
    name: string;  
}

export class Store extends StoreSelection {
    address: string;
    city: string;
    province: string;
    country: string;
    postalCode: string;
    parentStore: boolean;
    ratingGuid: string;
    groupGuid: string;
    latitude: number;
    longitude: number;

    toString() {
        return this.name;
    }
}